/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProjectStatus {
  NotSet = 'notSet',
  OnTrack = 'onTrack',
  OffTrack = 'offTrack',
  NotStarted = 'notStarted',
  Finished = 'finished',
  Discontinued = 'discontinued'
}
